<template>
	<div>
		<h4 class="heading-5">{{ heading }}</h4>
		<div class="asset-details-updates-timeline__module module module--on-white-bg">
			<div
				v-for="update in updates"
				:key="update.fundriseId"
				class="asset-details-updates-timeline__container display-flex gap-100"
			>
				<img
					class="asset-details-updates-timeline__icon"
					:src="`${update.portfolioContentType.iconUrl}`"
					alt=""
					role="presentation"
				/>
				<div class="display-flex flex-direction-column gap-50 pb-150">
					<div class="font-weight-bold">
						<div>{{ update.portfolioContentType.label }}</div>
						<div class="body-sm text-color-content-secondary">{{
							date(update.displayDate, CustomSpacetimeFormat.MONTH_DATE_YEAR)
						}}</div>
					</div>
					<div class="text-color-gray-80">{{ update.subtitle }}</div>
					<BaseLink
						:link="{ router: 'investor-update', params: { investorUpdateId: update.fundriseId } }"
						:style="{ width: 'fit-content' }"
						class="text-color-current-color"
					>
						<div class="asset-details-updates-timeline__card display-flex gap-100 p-100">
							<img
								v-if="update.thumbnailUrl"
								v-lazy="update.thumbnailUrl"
								class="asset-details-updates-timeline__card-thumbnail"
								alt=""
								role="presentation"
							/>
							<div>
								<div class="font-weight-bold">{{ update.title }}</div>
								<div class="body-sm cta-link--rust mt-25">View update</div>
							</div>
						</div>
					</BaseLink>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { date, pluralize } from '@filters/shared-filters';
import { AssetUpdateSanity } from 'types/assets';
import { computed } from 'vue';
import { CustomSpacetimeFormat } from 'types/spacetime-formats';

interface Props {
	updates: Array<AssetUpdateSanity>;
}

const props = defineProps<Props>();

const heading = computed((): string => pluralize(props.updates.length, 'Update'));
</script>

<style lang="scss">
@use '../../../styles/constants/colors.scss' as *;

.asset-details-updates-timeline {
	&__module {
		padding: 16px 16px 24px;
		margin-top: 1rem;
	}

	&__container {
		position: relative;
	}

	&__container:not(:last-of-type)::before {
		content: '';
		position: absolute;
		background-color: token('bg-tertiary');
		width: 2px;
		top: 35px;
		bottom: 11px;
		left: 11px;
	}

	&__icon {
		height: 24px;
		width: 24px;
	}

	&__card {
		max-width: 472px;
		background-color: token('greige');
		border-radius: 4px;
		border: 2px solid transparent;

		&:hover {
			color: token('content-primary');
			background-color: token('bg-secondary');
			border: 2px solid token('content-primary');
		}

		&-thumbnail {
			height: 64px;
			width: 64px;
			border-radius: 4px;
		}
	}
}
</style>
